import type { PublicSlotKey } from '#packages/apilib';
import type { CompPointersApi } from './compPointersApi';

export const CompPointersApiKey: PublicSlotKey<CompPointersApi> = {
  name: 'CompPointersApi',
  public: true,
};
